export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/desktop_banner_logo.5cc1b80.png";